import { ArrowBack, DeleteForever } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { LockButton, LockedChip } from 'components'
import { useLayout } from 'context'
import { deleteOhioBuildABox, lockOhioBuildABox, unlockOhioBuildABox } from 'controllers/ohioBuildABoxes'
import { OhioBuildABoxDto } from 'dtos/ohioBuildABoxes'
import { enqueueSnackbar } from 'notistack'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
  values: OhioBuildABoxDto | undefined
}

export default function OhioBuildABoxDetailsCard({ children, values }: React.PropsWithChildren<Props>) {
  const navigate = useNavigate()
  const { setIsLayoutLoading } = useLayout()

  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto' container spacing={1}>
                <Grid item>
                  <Typography fontWeight='bold' variant='h5'>
                    Build A Box
                  </Typography>
                </Grid>

                <Grid item>
                  <LockedChip isLocked={values?.isLocked} />
                </Grid>
              </Grid>

              <Grid item xs={12} sm='auto' container>
                <Grid item>
                  <Button onClick={() => navigate(-1)} color='primary' startIcon={<ArrowBack />} variant='text'>
                    BACK
                  </Button>
                </Grid>

                <Grid item sx={{ alignSelf: 'stretch' }}>
                  <Divider orientation='vertical' />
                </Grid>

                {children}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
